import { BaseAgent } from 'agents';

const SubscriptionAgent = {
    cancel: (reason, feedback) =>
        BaseAgent.post('/payment/unsubscribe', { feedback, reason }),
    giftRedeem: (voucher_code) =>
        BaseAgent.post('/payment/gift/redeem', { voucher_code }),
    retrieveCoupon: (code) =>
        BaseAgent.post('/payment/web/coupon/preview', { code }),
};

export default SubscriptionAgent;
